import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporter(customer_id, agro_exporter_id) {
    return RequesterV1.get(
      `customer/reporting/container/list_containers/${customer_id}/agro_exporter/${agro_exporter_id}`
    );
  },
  fetchAgroExporterProcess(customer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `customer/reporting/container/list_containers/${customer_id}/agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchContainer(customer_id, container_id) {
    return RequesterV1.get(
      `customer/reporting/container/list_reports/${customer_id}/container/${container_id}`
    );
  },
  fetchQualityTemplateMainRep(customer_id, quality_template_main_rep_id) {
    return RequesterV1.get(
      `customer/reporting/container/show_template_main_rep/${customer_id}/quality_template_main_rep/${quality_template_main_rep_id}`
    );
  },
  fetchProducers(customer_id, container_id) {
    return RequesterV1.get(
      `customer/reporting/container/show_template_main_rep/${customer_id}/list_producers/${container_id}`
    );
  },
  fetchOrganizations(customer_id, container_id) {
    return RequesterV1.get(
      `customer/reporting/container/show_template_main_rep/${customer_id}/list_organizations/${container_id}`
    );
  },
  fetchRepGuiHeaders(customer_id, container_id, quality_template_main_rep_id) {
    return RequesterV1.get(
      `customer/reporting/container/show_template_main_rep/${customer_id}/${container_id}/template_rep_gui_headers/${quality_template_main_rep_id}`
    );
  },
  fetchRepGuiData(
    customer_id,
    container_id,
    quality_template_main_rep_id,
    search_params
  ) {
    return RequesterV1.get(
      `customer/reporting/container/show_template_main_rep/${customer_id}/${container_id}/template_rep_gui_data/${quality_template_main_rep_id}` +
        `/search?producer=${search_params.producer}&organization=${search_params.organization}&registered_at=${search_params.registered_at}`
    );
  },
  downloadRepXlsx(
    customer_id,
    container_id,
    quality_template_main_rep_id,
    search_params
  ) {
    return RequesterV1.get(
      `customer/reporting/container/show_template_main_rep/${customer_id}/${container_id}/template_rep_xlsx/${quality_template_main_rep_id}` +
        `/search?producer=${search_params.producer}&organization=${search_params.organization}&registered_at=${search_params.registered_at}`,
      { responseType: "blob" }
    );
  }
};
